import Vue from 'vue'
import store from './store'
import Detail from './detail.vue'
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';

Vue.config.productionTip = true

new Vue(Vue.util.extend({ store }, Detail)).$mount('#app');